import React from "react";
import { useLocation, useParams } from "react-router-dom";
import EditRole from "./EditRole";

const EditRoleWrapper = (props) => {
  const location = useLocation();
  const { appid, roleid } = useParams();

  return (
    <EditRole
      {...props}
      location={location}
      applicationid={appid}
      roleid={roleid}
      breadcrumbs={[
        ["/", "Applications"],
        [`/manage/${appid}`, "My Application"],
        [`/manage/${appid}/role/${roleid}`, "My Role"],
      ]}
    />
  );
};

export default EditRoleWrapper;
